<template>
  <div class="container">
    <h4 class="text-center">{{data.trip.heading}}({{data.trip.start}}) {{data.trip.meetPlace}} {{data.trip.meetTime}} </h4>
    <div class="row d-row" v-for="(key, val) in data.selector">
      <div class="col-xs-6">
        <table class="table table-bordered">
          <caption class="text-danger">{{key}}</caption>
          <thead>
            <tr>
              <th>选项</th>
              <th>选择次数</th>
              <th>比例</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in val.answer" track-by="$index">
              <td>{{item.answer}}</td>
              <td>{{item.number}}</td>
              <td>{{item.percent}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-5">
        <vue-chart type="doughnut" :data="val.chart"></vue-chart>
      </div>
    </div>
    <div class="row d-row">
      <div class="col-xs-6" v-for="(key, val) in data.question">
        <table class="table table-bordered">
          <caption class="text-danger">{{key}}</caption>
<!--           <thead>
            <tr>
              <th>回答</th>
            </tr>
          </thead> -->
          <tbody>
            <tr v-for="ans in val" track-by="$index">
              <td>{{ans.answer}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '../../libs/config'
  import VueChart from 'vue-chart'

  export default {
    components: {
      VueChart
    },
    data () {
      return {
        data: {
          trip: {},
          question: {},
          selector: {}
        }
      }
    },
    methods: {
      fetchData () {
        return this.$http.get(`${config.apiWe}/product/feedback/${this.$route.params.id}/result`)
          .then(({data}) => {
            this.data = data
            this.genChartData(this.data.selector)
          })
      },
      genChartData (selector = {}) {
        Object.keys(selector).forEach(key => {
          let item = selector[key]
          item.chart = {
            labels: [],
            datasets: [
              {
                backgroundColor: [
                  '#41B883',
                  '#E46651',
                  '#00D8FF',
                  '#DD1B16',
                  '#75FF0D',
                  '#E8A00C',
                  '#00FFEA',
                  '#FF0000',
                  '#3B0CE8'
                ],
                data: []
              }
            ]
          }
          item.answer.forEach((ans) => {
            item.chart.labels.push(ans.answer)
            item.chart.datasets[0].data.push(ans.number)
          })
        })
      }
    },
    route: {
      data () {
        return this.fetchData()
      }
    }
  }
</script>

<style scoped>
  .d-row {
    margin-bottom: 50px;
  }
</style>



/** WEBPACK FOOTER **
 ** Item.vue?29f3e98b
 **/